import React from "react"
import { SortIcon } from "components/Table_SortColumnIcon"

const favoriteReportsListColumns = () => {
  return [
    {
      text: "id",
      dataField: "id",
      sort: true,
      hidden: true,
      formatter: (cellContent, place) => <>{place?.id}</>,
    },
    {
      text: "Place",
      dataField: "name",
      sort: true,
      sortCaret: order => <SortIcon order={order} />,
      formatter: (cellContent, place) => <>{place?.name}</>,
    },
    {
      text: "Address",
      dataField: "address_street_1",
      sort: true,
      sortCaret: order => <SortIcon order={order} />,
      formatter: (cellContent, place) => {
        let placeStr = ""
        place?.address_street_1
          ? (placeStr += place?.address_street_1 + ", ")
          : placeStr
        place?.address_street_2
          ? (placeStr += place?.address_street_2 + ", ")
          : placeStr
        place?.city ? (placeStr += place?.city + ", ") : placeStr
        place?.state ? (placeStr += place?.state + ", ") : placeStr
        place?.country_code ? (placeStr += place.country_code) : placeStr
        return <>{placeStr}</>
      },
    },
    {
      text: "Type",
      dataField: "category_name",
      sort: true,
      sortCaret: order => <SortIcon order={order} />,
      formatter: (cellContent, place) => <>{place?.category_name}</>,
    },
    {
      text: "# of favorites",
      dataField: "favorite_places_count",
      sort: true,
      sortCaret: order => <SortIcon order={order} />,
      formatter: (cellContent, place) => <>{place?.favorite_places_count}</>,
    },
  ]
}

export default favoriteReportsListColumns
